export default __webpack_public_path__ + "static/media/028-mail box.6a3d66db.svg";